import React, { useState, useEffect } from "react";
import { connect } from "react-redux";

import { adminLogin } from "../../../action/user_action";
import SocialLogin from "./SocialLogin";
import { sidebarForRole } from "../../../../config/sidebarForRole";

const GSuitImpl = (props) => {
  //Set initial state
  const [error, handleError] = useState("");
  const [count, handleCount] = useState(1);

  //Checking the admin info
  useEffect(() => {
    if (localStorage.getItem("adminInfo") !== null) {
      console.log(sidebarForRole[localStorage.getItem("adminRole")]);
      window.location = sidebarForRole[localStorage.getItem("adminRole")]? sidebarForRole[localStorage.getItem("adminRole")].default: sidebarForRole.user.default;
    }
  }, []);

  useEffect(() => {
    let err = props.errorMessage;
    if (err) {
      setError(err);
    }
  }, [props.errorMessage]);

  //Go for social login
  const socialLogin = (user) => {
    console.log("user on successful login", user);
    const userInfo = user._profile;
    localStorage.setItem("admin", userInfo.email);
    localStorage.setItem("role", userInfo.role);
    if (user._provider == "google") {
      const id_token = user._token.idToken;
      var email = userInfo.email;
      props.adminLogin({ id_token, email });
    }
  };

  const failedLogin = (err) => {
    console.log("err in g-suit login", err);
    refresh();
  };
  const refresh = () => {
    window.location.reload(true);
  };

  const setError = (err) => {
    handleError(err);
    handleCount(count + 1);
    renderErrorBlock();
    setTimeout(refresh, 2000);
  };

  //Handle error
  const renderErrorBlock = (props) => {
    if (!error) {
      return null;
    }
    return <div className="alert alert-danger">{error}</div>;
  };

  return (
    <div className="review-wrapper">
      <div className="navbar-header dashboard-header clearfix">
        <div className="logo-dashboard">
          <a id="logo">
            <img className="logo-trans" src="../../../assets/images/new_logo.png" />
            <span className="supportlink" style={{ position:'relative', bottom:'38px', left:'17px', color:'white'}}><a style={{color:'white'}} target="_blank" href="https://docs.google.com/forms/d/e/1FAIpQLSfEbCiG9bLYZvO1tK9Kczswnv7905Z9g1DHx09YjKIEkTYQOg/viewform">Support Portal</a> </span>         

          </a>
        </div>
      </div>
      <div className="review-container login-google">
        <div className="review-container-inner">
          {renderErrorBlock()}
          <span>Sign in to BigFM Portal</span>

          <SocialLogin
            provider="google"
            appId={process.env.googleApiKey}
            onLoginSuccess={socialLogin}
            onLoginFailure={failedLogin}
          >
            Login with <img src="../../../assets/images/google_logo.png" className="g_color" />
            <img src="../../../assets/images/google_logo_white.png" className="g_white" /> Account
          </SocialLogin>
        </div>
      </div>
    </div>
  );
};

export default connect(
  (state) => ({
    errorMessage: state.user.get("errorMessage"),
  }),
  {
    adminLogin,
  }
)(GSuitImpl);



// WEBPACK FOOTER //
// ./web/components/admin/login/login.js